import StatePage from '../../components/StatePage/StatePage';

const WorkInProgress = () => <StatePage icon="clock" eyebrow="Foro LIS" title="Estamos trabajando en este espacio" text="El foro todavía no está disponible. Pronto encontrarás aquí un nuevo espacio para la comunidad." actionLabel="Volver al inicio" />;

export default WorkInProgress;
